import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpParams, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PedidoCampoPersonalizadoService {

  constructor(private http: HttpClient) {}

  consultarPedidoCampoPersonalizadoComPaginacao(descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, tipoAplicacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoAplicacao', tipoAplicacao);

    if (descri.trim() !== '') {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/PedidoCampoPersonalizado/ListaPag',
      {
        params: parametros
      });
  }

  consultarTodosPedidoCampoPersonalizado() {
    return this.http.get<any>(globals.apiUrl + '/api/PedidoCampoPersonalizado/Lista');
  }

  consultarPorIdPedidoCampoPersonalizado(id) {
    return this.http.get<any>(globals.apiUrl + '/api/PedidoCampoPersonalizado/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(campoPersonalizado) {
    return this.http.post(globals.apiUrl + '/api/PedidoCampoPersonalizado/Salvar', campoPersonalizado);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/PedidoCampoPersonalizado/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  verificaSePodeExcluirItem(id) {
    return this.http.get<any>(globals.apiUrl + '/api/PedidoCampoPersonalizado/PodeExcluirItem',
      { params: new HttpParams().set('idItem', id) });
  }
}
